import React from "react";
import "~/assets/sass/pages/round/external/external.scss";
import ExternalContext from "./ExternalContext";
import LoginContainer from "./login/container/LoginContainer";

const Login = () => {
	return (
		<ExternalContext>
			<LoginContainer />
		</ExternalContext>
	);
};

export default Login;
